/**
 * Product screenshot manifest for the marketing homepage.
 *
 * Each entry maps a product area to a capture file under
 * `packages/web/public/media/screenshots/<file>` (served at
 * `/media/screenshots/<file>`).
 *
 * `BrowserFrame` renders an elegant gradient fallback when a file 404s, and
 * the real screenshot appears automatically the moment the file lands —
 * no code change needed.
 */
export interface Screenshot {
  /** Stable key, matches the README convention. */
  key: string;
  /** Filename under public/media/screenshots/. */
  file: string;
  /** App route the screenshot depicts (shown in the frame's URL bar). */
  url: string;
  /** Human-readable caption shown in the fallback panel and under the frame. */
  label: string;
}

export const SCREENSHOTS: Screenshot[] = [
  { key: 'discover', file: 'discover.png', url: '/app/discover', label: 'Discover — federal feeds' },
  { key: 'readiness', file: 'readiness.png', url: '/app/readiness', label: 'Readiness — eligibility checklists' },
  { key: 'vault', file: 'vault.png', url: '/app/vault', label: 'Document vault' },
  { key: 'registrations', file: 'registrations.png', url: '/app/registrations', label: 'Registrations — SAM.gov & grants.gov' },
  { key: 'gonogo', file: 'gonogo.png', url: '/app/discover', label: 'Go/no-go scoring — opportunity detail' },
  { key: 'brief', file: 'brief.png', url: '/app/overview', label: 'Morning brief' },
  { key: 'proposals', file: 'proposals.png', url: '/app/proposals', label: 'Proposal workspace' },
];

export const SCREENSHOT_BASE = '/media/screenshots';
